// Routes des marchés publics et fournisseurs (lot L4-C, M15), raccordées dans Application.tsx par une
// seule ligne.
import type { RouteObject } from 'react-router';
import { PageCommandes } from './PageCommandes';
import { PageConsultations } from './PageConsultations';
import { PageContrats } from './PageContrats';
import { PageFournisseurs } from './PageFournisseurs';

export const routesAchats: RouteObject[] = [
  { path: '/achats', element: <PageConsultations /> },
  { path: '/achats/fournisseurs', element: <PageFournisseurs /> },
  { path: '/achats/contrats', element: <PageContrats /> },
  { path: '/achats/commandes', element: <PageCommandes /> },
];
